import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import { getPoolContract } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import { LUCKIFY_CONTRACT_ADDRESS, pool } from "../../utils/Enviroment";

const SqurtPrice = () => {
  const { account } = useWeb3React();
  const web3 = useWeb3();
  const contractAddress = pool;
  const SqurtPriceHood = useCallback(async () => {
    const contract = getPoolContract(contractAddress, web3);
    if (!contract) {
      console.error("Contract not initialized properly.");
      return;
    }
    try {
      const SqurtPrice = await contract?.methods?.slot0()?.call();
      return SqurtPrice.sqrtPriceX96;
    } catch (error) {
      console.error("Error fetching balance:", error.message || error);
      throw error;
    }
  }, [account]);
  return { SqurtPriceHood };
};

export default SqurtPrice;
